import { Spacing } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { type ReactElement, memo } from 'react';
import { useSelector } from 'react-redux';
import { QuotaLandingSelectors } from 'reactApp/modules/quotaLanding/quotaLanding.selector';

import styles from './Title.css';

interface TitleProps {
    title: string | ReactElement;
    description?: string;
}

export const Title = memo(({ title, description }: TitleProps) => {
    const isMobile = useSelector(QuotaLandingSelectors.isMobile);

    return (
        <div
            className={classNames(styles.root, {
                [styles.root_mobile]: isMobile,
            })}
        >
            <div className={styles.title}>{title}</div>
            {description && (
                <>
                    <Spacing size={isMobile ? 4 : 12} />
                    <div className={styles.description}>{description}</div>
                </>
            )}
        </div>
    );
});

Title.displayName = 'Title';
